import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";

import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import Kits from "@/pages/Kits";
import KitDetail from "@/pages/KitDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import AuthPage from "@/pages/AuthPage";
import Account from "@/pages/Account";
import OrderDetail from "@/pages/OrderDetail";
import Admin from "@/pages/Admin";
import PujaGuides from "@/pages/PujaGuides";
import PaymentResult from "@/pages/PaymentResult";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";
import ReturnPolicy from "@/pages/ReturnPolicy";

function Shell() {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]"><Outlet /></main>
      <Footer />
      <WhatsAppFAB />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Shell/>}>
            <Route path="/" element={<Home/>}/>
            <Route path="/category/:slug" element={<Category mode="category"/>}/>
            <Route path="/product/:slug" element={<ProductDetail/>}/>
            <Route path="/kits" element={<Kits/>}/>
            <Route path="/kit/:slug" element={<KitDetail/>}/>
            <Route path="/cart" element={<Cart/>}/>
            <Route path="/checkout" element={<Checkout/>}/>
            <Route path="/login" element={<AuthPage mode="login"/>}/>
            <Route path="/register" element={<AuthPage mode="register"/>}/>
            <Route path="/account" element={<Account/>}/>
            <Route path="/wishlist" element={<Account/>}/>
            <Route path="/order/:id" element={<OrderDetail/>}/>
            <Route path="/admin" element={<Admin/>}/>
            <Route path="/guides" element={<PujaGuides/>}/>
            <Route path="/payment-result" element={<PaymentResult/>}/>
            <Route path="/about" element={<AboutUs/>}/>
            <Route path="/contact" element={<ContactUs/>}/>
            <Route path="/privacy" element={<PrivacyPolicy/>}/>
            <Route path="/terms" element={<TermsConditions/>}/>
            <Route path="/refund-policy" element={<RefundPolicy/>}/>
            <Route path="/shipping-policy" element={<ShippingPolicy/>}/>
            <Route path="/return-policy" element={<ReturnPolicy/>}/>
            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/returns" element={<ReturnPolicy/>}/>
            <Route path="/shipping" element={<ShippingPolicy/>}/>
            <Route path="/best-sellers" element={<Category mode="best"/>}/>
            <Route path="/search" element={<Category mode="search"/>}/>
            <Route path="/festival/:name" element={<Category mode="festival"/>}/>
            <Route path="/deity/:name" element={<Category mode="deity"/>}/>
            <Route path="/festivals" element={<Kits/>}/>
            <Route path="/offers" element={<Category mode="best"/>}/>
            <Route path="*" element={<div className="p-20 text-center"><h1 className="font-serif text-3xl">Page not found</h1></div>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
